module.exports = __webpack_public_path__ + "fonts/Rift-Bold.68340089.ttf";